import { BASE_URL } from "../url";
import { isBannoServiceProvider } from "./banno";
import { isCsiServiceProvider } from "./csi";
import { isLuminServiceProvider } from "./lumin";
import { cardControlsRedirectQ2, isQ2ServiceProvider } from "./q2";

export const homeRedirectTenantWise = (props, fromProps = true) => {
    if (isQ2ServiceProvider(props, fromProps)) {
        if (window.tecton && window.tecton.actions) {
            window.tecton.actions.navigateTo('dashboard')
        } else {
            console.warn(`tecton not able to navigate`)
        }

    }

    if (isBannoServiceProvider(props, fromProps) && window.parent.banno) {
        window?.parent?.banno?.redirectToHome();
    }

    if(isCsiServiceProvider(props,fromProps)){
        window.location.href = '/parent/tenant/enrollment';
    }
}

export const cardControlsRedirect = (props) => {
    if (isQ2ServiceProvider(props)) {
        cardControlsRedirectQ2(props);
    }

    if (isBannoServiceProvider(props)) {
        window.parent.location.href = BASE_URL.CARD_CONTROLS_URL_TINKER;
    }
}

export const isInvestmentEnable = (featureTogglesResponse) => {
    //console.log(featureTogglesResponse);
    return (featureTogglesResponse.find(e => e === 'InvestmentsOnly') ? false : true);
}